import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { CustomerProfile, CustomerProfileResponse } from './types';

const ENDPOINT = '/api/customer/profile';

let inFlight: Promise<CustomerProfile | null> | null = null;

export function clearCustomerProfileCache(): void {
  inFlight = null;
}

export function getCustomerProfile(): Promise<CustomerProfile | null> {
  if (inFlight) {
    return inFlight;
  }
  const request: Promise<CustomerProfile | null> = requestCustomerProfile().catch(() => {
    if (inFlight === request) {
      inFlight = null;
    }
    return null;
  });
  inFlight = request;
  return request;
}

async function requestCustomerProfile(): Promise<CustomerProfile | null> {
  const { accountUrl } = useTravelataAppConfig();

  if (!accountUrl) return null;

  const response = await useTravelataApiService().get<CustomerProfileResponse>(`${accountUrl}${ENDPOINT}`);

  return response?.success === true && response.data ? response.data : null;
}
